import React from 'react';
import { Alert } from 'antd';

import { RequestResponseCard } from '../Common/RequestResponseCard';
import { InfoCard } from './InfoCard';
import { useSupplySourceSummaryResolver } from './useSupplySourceSummaryResolver';

export const SupplySource = ({ isLoading, data, error, type }) => {
  const summaryData = useSupplySourceSummaryResolver(type, data);

  return error ? (
    <Alert type="error" message={error.message || error} />
  ) : (
    <>
      <InfoCard title="Summary" isLoading={isLoading} data={summaryData} />
      <RequestResponseCard isLoading={isLoading} data={data?.rawData} header="Request" />
    </>
  );
};
